import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export interface EddInfo {
  RmiCompanyId: string,
  RmiProvKeyId: string,
  RmiMembMpiNo: string,
  RmiEddDate: string
}

export interface GetEddDateResponse {
  RmiEstDueDate: string,
  RmiLmpDate: null
}


export const getEddDate = (companyId: string, mpiNo: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_EDD_DATE_REQUEST });

  return api.eligibility.edd.getDate(companyId, mpiNo)
    .then((res: any) => {

      dispatch({
        type: types.GET_EDD_DATE_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_EDD_DATE_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const saveEddDate = (eddInfo: EddInfo) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.eligibilityEDD.isSaving) { return Promise.reject(); }

  dispatch({ type: types.SAVE_EDD_DATE_REQUEST });

  const details = {
    RmiCompanyId: eddInfo.RmiCompanyId,
    RmiProvKeyId: eddInfo.RmiProvKeyId,
    RmiMembMpiNo: eddInfo.RmiMembMpiNo,
    RmiEddDate: eddInfo.RmiEddDate
  };

  return api.eligibility.edd.saveDate(details)
    .then((res: any) => {

      dispatch({
        type: types.SAVE_EDD_DATE_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.SAVE_EDD_DATE_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
